(function () {
  'use strict';

  function array(value) {
    return Array.prototype.slice.call(value || []);
  }

  function parseJSON(node, fallback) {
    if (!node) return fallback;
    try {
      return JSON.parse(node.textContent || '');
    } catch (error) {
      return fallback;
    }
  }

  function normalize(value) {
    return String(value == null ? '' : value).trim().toLowerCase();
  }

  function normalizeSize(value) {
    var size = String(value == null ? '' : value).trim().toUpperCase().replace(/[\s_-]+/g, '');
    if (size === 'XXS') return '2XS';
    if (size === 'XXXS') return '3XS';
    if (size === 'XXL' || size === '2X') return '2XL';
    if (size === 'XXXL' || size === '3X') return '3XL';
    if (size === 'XXXXL' || size === '4X') return '4XL';
    return size;
  }

  function variantOptions(variant) {
    if (Array.isArray(variant.options)) return variant.options.map(String);
    return [variant.option1, variant.option2, variant.option3].filter(function (value) {
      return value != null;
    }).map(String);
  }

  function priceAmount(value) {
    if (typeof value === 'string' && value.indexOf('.') > -1) return Number(value);
    return Number(value || 0) / 100;
  }

  function formatMoney(value, currency) {
    var amount = priceAmount(value);
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency',
        currency: currency || 'USD',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(amount);
    } catch (error) {
      return '$' + amount.toFixed(2);
    }
  }

  function imageIdFromVariant(variant) {
    if (!variant) return '';
    var image = variant.featured_image || variant.featured_media;
    var id = image && (image.id || image.media_id);
    return id == null ? '' : String(id).split('/').pop();
  }

  function initProduct(root) {
    if (!root || root.getAttribute('data-ura4-ready') === 'true') return;
    root.setAttribute('data-ura4-ready', 'true');

    var variants = parseJSON(root.querySelector('[data-ura4-variants]'), []);
    var system = window.URAProductSystemV1 ? window.URAProductSystemV1.create(root, variants) : null;
    var copy = parseJSON(root.querySelector('[data-ura4-copy]'), {});
    var displayLabels = {
      bestMatch: copy.recommended,
      available: copy.available
    };

    // Display labels are localized by Liquid; input values stay canonical.
    function displayColor(input) {
      return input ? input.getAttribute('data-ura4-display-label') || input.value : '';
    }
    var urlState = new URL(window.location.href);
    if (urlState.searchParams.has('ura_choose_size')) array(root.querySelectorAll('[data-ura4-size-input]')).forEach(function(input){ input.checked = false; });
    var groups = array(root.querySelectorAll('[data-ura4-option]')).sort(function (a, b) {
      return Number(a.getAttribute('data-option-index')) - Number(b.getAttribute('data-option-index'));
    });
    var technicalIndexes = groups.filter(function (group) {
      return group.hidden || group.hasAttribute('hidden') || group.getAttribute('aria-hidden') === 'true';
    }).map(function (group) {
      return Number(group.getAttribute('data-option-index'));
    });
    var currency = root.getAttribute('data-currency') || 'USD';
    var hiddenVariant = root.querySelector('[data-ura4-variant-id]');
    var price = root.querySelector('[data-ura4-price]');
    var availability = root.querySelector('[data-ura4-availability]');
    var add = root.querySelector('[data-ura4-add]');
    var addLabel = root.querySelector('[data-ura4-add-label]');
    var addPrice = root.querySelector('[data-ura4-add-price]');
    var colorName = root.querySelector('[data-ura4-color-name]');
    var sizeStatus = root.querySelector('[data-ura4-size-status]');
    var express = root.querySelector('[data-ura4-express]');
    var form = root.querySelector('.ura4-buy__form');
    var gallery = window.URAProductGalleryV4 ? window.URAProductGalleryV4.init(root) : null;
    var fitApi = null;
    var recommendedSize = '';
    var autoSelectedSize = '';

    function isTechnicalIndex(index) {
      return technicalIndexes.indexOf(index) > -1;
    }

    function selectedValues() {
      var values = [];
      groups.forEach(function (group) {
        var index = Number(group.getAttribute('data-option-index'));
        var checked = group.querySelector('[data-ura4-option-input]:checked');
        values[index] = checked ? checked.value : '';
      });
      return values;
    }

    function exactVariant(values) {
      return variants.find(function (variant) {
        var options = variantOptions(variant);
        return values.every(function (value, index) {
          return normalize(options[index]) === normalize(value);
        });
      }) || null;
    }

    function syncTechnicalOptions(variant) {
      if (!variant || !technicalIndexes.length) return;
      var options = variantOptions(variant);

      technicalIndexes.forEach(function (index) {
        var group = groups.find(function (candidate) {
          return Number(candidate.getAttribute('data-option-index')) === index;
        });
        if (!group) return;

        var input = array(group.querySelectorAll('[data-ura4-option-input]')).find(function (candidate) {
          return normalize(candidate.value) === normalize(options[index]);
        });
        if (input) input.checked = true;
      });
    }

    function visibleMatch(variant, values, ignoredIndex, candidateValue) {
      var options = variantOptions(variant);
      return values.every(function (value, index) {
        if (isTechnicalIndex(index)) return true;
        if (index === ignoredIndex) return normalize(options[index]) === normalize(candidateValue);
        return !value || normalize(options[index]) === normalize(value);
      });
    }

    function precedingMatch(variant, values, optionIndex, candidateValue) {
      var options = variantOptions(variant);
      if (normalize(options[optionIndex]) !== normalize(candidateValue)) return false;
      var group = groups.find(function(item){return Number(item.dataset.optionIndex) === optionIndex;});
      if (group && group.querySelector('[data-ura4-color-input]')) return true;
      return values.every(function(value,index){
        if (index === optionIndex || isTechnicalIndex(index)) return true;
        return !value || normalize(options[index]) === normalize(value);
      });
    }

    function needsSize() {
      return Boolean(root.querySelector('[data-ura4-size-input]') && !root.querySelector('[data-ura4-size-input]:checked'));
    }

    function resolveVariant() {
      var values = selectedValues();
      if (system) return needsSize() ? null : system.resolve(values);
      if (needsSize()) return null;
      var exact = exactVariant(values);
      if (exact && exact.available !== false) return exact;

      var available = variants.find(function (variant) {
        return variant.available !== false && visibleMatch(variant, values, -1, '');
      });
      if (available) {
        syncTechnicalOptions(available);
        return available;
      }

      var anyMatch = variants.find(function (variant) {
        return visibleMatch(variant, values, -1, '');
      });
      if (anyMatch) {
        syncTechnicalOptions(anyMatch);
        return anyMatch;
      }

      return exact;
    }

    function updateOptionAvailability() {
      var values = selectedValues();
      if (system) { system.updateOptions(groups, values); return; }

      groups.forEach(function (group) {
        var optionIndex = Number(group.getAttribute('data-option-index'));
        var technical = isTechnicalIndex(optionIndex);

        array(group.querySelectorAll('[data-ura4-option-input]')).forEach(function (input) {
          if (technical) {
            input.disabled = false;
            return;
          }

          input.disabled = !variants.some(function (variant) {
            return variant.available !== false && precedingMatch(variant, values, optionIndex, input.value);
          });
        });
      });
    }

    function isSizeAvailable(size) {
      var target = array(root.querySelectorAll('[data-ura4-size-input]')).find(function (input) {
        return normalizeSize(input.value) === normalizeSize(size);
      });
      return Boolean(target && !target.disabled);
    }

    function markRecommendation(size) {
      recommendedSize = size;
      array(root.querySelectorAll('[data-ura4-size-note]')).forEach(function (note) {
        var input = note.closest('label') && note.closest('label').querySelector('[data-ura4-size-input]');
        note.textContent = input && normalizeSize(input.value) === normalizeSize(size) ? displayLabels.bestMatch : '';
      });
      var chosen = root.querySelector('[data-ura4-size-input]:checked');
      if (sizeStatus && chosen && normalizeSize(chosen.value) === normalizeSize(size)) {
        sizeStatus.textContent = chosen.value + ' · ' + displayLabels.bestMatch + ' · URA Fit';
      }
    }

    function clearRecommendation() {
      var hadRecommendation = Boolean(recommendedSize);
      recommendedSize = '';
      array(root.querySelectorAll('[data-ura4-size-note]')).forEach(function (note) {
        note.textContent = '';
      });
      array(root.querySelectorAll('[data-ura4-chart-row]')).forEach(function (row) {
        row.classList.remove('is-recommended');
        var label = row.querySelector('[data-ura4-chart-match]');
        if (label) label.textContent = '';
      });
      if (sizeStatus && hadRecommendation) {
        var chosen = root.querySelector('[data-ura4-size-input]:checked');
        sizeStatus.textContent = chosen ? chosen.value + ' · ' + copy.chosen + '.' : copy.select_prompt;
      }
    }

    function selectSize(size, fromFit) {
      var target = array(root.querySelectorAll('[data-ura4-size-input]')).find(function (input) {
        return normalizeSize(input.value) === normalizeSize(size) && !input.disabled;
      });
      if (!target) return false;
      autoSelectedSize = fromFit ? normalizeSize(target.value) : '';

      target.setAttribute('data-ura4-fit-selecting', '');
      if (!target.checked) {
        target.checked = true;
        target.dispatchEvent(new Event('change', { bubbles: true }));
      } else {
        updateUI(resolveVariant(), Boolean(fromFit));
      }
      window.setTimeout(function () {
        target.removeAttribute('data-ura4-fit-selecting');
      }, 0);

      if (sizeStatus) sizeStatus.textContent = target.value + ' · ' + copy.fit_chosen + '.';
      return true;
    }

    function clearAutomaticSize() {
      var chosen = root.querySelector('[data-ura4-size-input]:checked');
      if (autoSelectedSize && chosen && normalizeSize(chosen.value) === autoSelectedSize) {
        chosen.checked = false;
        autoSelectedSize = '';
        updateUI(null, false);
      }
      autoSelectedSize = '';
    }
    function continueToPurchase() {
      if (needsSize() || !resolveVariant() || !resolveVariant().available) return;
      root.dispatchEvent(new CustomEvent('ura:fit-purchase-ready', {bubbles:true}));
      var target = root.querySelector('[data-ura-fit-purchase]');
      if (target) target.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'center'});
      if (add) add.focus({preventScroll:true});
    }

    function syncComponentItems(variant) {
      if (!form || !hiddenVariant) return;
      array(form.querySelectorAll('[data-ura4-component-item]')).forEach(function(input) { input.remove(); });
      var items = variant && variant.componentItems;
      hiddenVariant.disabled = Boolean(items && items.length);
      if (!items) return;
      items.forEach(function(item,index) {
        ['id','quantity'].forEach(function(key) {
          var input = document.createElement('input');
          input.type = 'hidden'; input.name = 'items[' + index + '][' + key + ']';
          input.value = item[key]; input.setAttribute('data-ura4-component-item',''); form.appendChild(input);
        });
      });
    }

    function updateUI(variant, fromFit) {
      var selected = variant || resolveVariant();
      if (selected) syncTechnicalOptions(selected);
      updateOptionAvailability();

      var available = Boolean(selected && selected.available !== false);
      var displayVariant = system ? selected || system.display(selectedValues()) : selected || variants.find(function(v){return v.available !== false && visibleMatch(v, selectedValues(), -1, '');}) || variants[0];
      if (hiddenVariant) {
        var nextId = selected ? String(selected.id) : '';
        if (String(hiddenVariant.value) !== nextId) {
          hiddenVariant.value = nextId;
          hiddenVariant.setAttribute('value',nextId);
          hiddenVariant.dispatchEvent(new Event('change',{bubbles:true}));
        }
      }
      if (displayVariant && price) price.textContent = formatMoney(displayVariant.price, currency);
      if (displayVariant && addPrice) addPrice.textContent = formatMoney(displayVariant.price, currency);

      if (availability) {
        availability.textContent = displayVariant && displayVariant.available !== false ? displayLabels.available : copy.sold_out;
        availability.classList.toggle('is-sold-out', !displayVariant || displayVariant.available === false);
      }

      if (add) {
        add.disabled = !needsSize() && !available;
        add.type = needsSize() ? 'button' : 'submit';
      }
      if (addLabel) addLabel.textContent = needsSize() ? copy.choose_size : available ? copy.add : copy.sold_out;
      syncComponentItems(selected);
      if (express) express.hidden = needsSize() || !available || Boolean(selected && selected.componentItems);

      var selectedColor = root.querySelector('[data-ura4-color-input]:checked');
      if (colorName && selectedColor) colorName.textContent = displayColor(selectedColor);
      var chosenSize = root.querySelector('[data-ura4-size-input]:checked');
      if (sizeStatus && needsSize()) sizeStatus.textContent = copy.select_prompt;
      var selectionSummary = root.querySelector('[data-ura4-selection]');
      if (selectionSummary) {
        selectionSummary.hidden = needsSize() || !available;
        selectionSummary.textContent = [displayColor(selectedColor), chosenSize && chosenSize.value].filter(Boolean).join(' / ');
      }
      array(root.querySelectorAll('[data-ura4-chart-row]')).forEach(function(row) {
        var isSelected = Boolean(chosenSize && normalizeSize(row.getAttribute('data-size')) === normalizeSize(chosenSize.value));
        row.classList.toggle('is-selected', isSelected);
        if (isSelected) row.setAttribute('aria-current','true');
        else row.removeAttribute('aria-current');
      });

      if (displayVariant && gallery) {
        var galleryVariant = system ? system.galleryVariant(selectedValues()) : displayVariant;
        if (typeof gallery.filterForVariant === 'function') gallery.filterForVariant(galleryVariant);
        else if (typeof gallery.showImageId === 'function') gallery.showImageId(imageIdFromVariant(displayVariant));
      }

      var urlVariant = system ? system.galleryVariant(selectedValues()) : selected || (needsSize() ? displayVariant : null);
      if (urlVariant && /^https?:$/.test(window.location.protocol) && window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        if (system) url.searchParams.set('ura_buy', system.mode());
        url.searchParams.set('variant', String(urlVariant.id).split('/').pop());
        if (needsSize()) url.searchParams.set('ura_choose_size', '1');
        else url.searchParams.delete('ura_choose_size');
        if (url.toString() !== window.location.href) {
          window.history.replaceState(window.history.state, '', url.toString());
          window.dispatchEvent(new Event('ura:location-updated'));
        }
      }
    }

    groups.forEach(function (group) {
      group.addEventListener('change', function (event) {
        if (!event.target.matches('[data-ura4-option-input]')) return;

        var manualSize = event.target.matches('[data-ura4-size-input]') &&
          !event.target.hasAttribute('data-ura4-fit-selecting');

        if (manualSize) {
          autoSelectedSize = '';
          if (fitApi && fitApi.manualSelection) fitApi.manualSelection();
          clearRecommendation();
          if (sizeStatus) sizeStatus.textContent = event.target.value + ' · ' + copy.chosen + '.';
        }

        if (event.target.matches('[data-ura4-color-input]')) {
          updateOptionAvailability();
          var size = root.querySelector('[data-ura4-size-input]:checked');
          if (size && size.disabled) {
            size.checked = false;
            clearRecommendation();
            if (sizeStatus) sizeStatus.textContent = copy.select_prompt;
          }
        }
        updateUI(resolveVariant(), false);
        if ((manualSize || event.target.matches('[data-ura4-color-input]')) && fitApi) fitApi.refresh();
      });
    });

    var fitHooks = {
      isSizeAvailable: isSizeAvailable,
      selectSize: selectSize,
      markRecommendation: markRecommendation,
      clearRecommendation: clearRecommendation,
      clearAutomaticSize: clearAutomaticSize,
      continueToPurchase: continueToPurchase
    };
    fitApi = system ? system.initFit(fitHooks) : window.URAProductFitV4 ? window.URAProductFitV4.init(root, fitHooks) : null;
    if (system) system.onChange(function () {
      clearRecommendation();
      updateOptionAvailability();
      var currentSize = root.querySelector('[data-ura4-size-input]:checked');
      if (currentSize && currentSize.disabled) currentSize.checked = false;
      updateUI(resolveVariant(), false);
      if (fitApi) fitApi.refresh();
    });

    updateUI(resolveVariant(), false);
    try{
      var journey=JSON.parse(sessionStorage.getItem('ura-shop-journey')||'null');
      if(journey&&journey.handle===root.dataset.productHandle&&Date.now()-journey.time<1800000){
        var journeyColor = root.querySelector('[data-ura4-color-input]:checked');
        var matchingColor = !journeyColor || normalize(journey.color) === normalize(journeyColor.value);
        if(gallery&&journey.imageId&&matchingColor)gallery.showImageId(journey.imageId,false);
        var back=root.querySelector('[data-ura-shop-return]');
        if(back&&journey.shop&&journey.shop.indexOf('/collections/')===0)back.href=journey.shop;
      }
    }catch(error){}

    if (add) {
      add.addEventListener('click', function (event) {
        if (!needsSize()) return;
        event.preventDefault();
        if (sizeStatus) sizeStatus.textContent = copy.select_prompt;
        var firstSize = root.querySelector('[data-ura4-size-input]:not(:disabled)');
        if (firstSize) {
          var target = firstSize.closest('fieldset') || firstSize.closest('label') || firstSize;
          target.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
          firstSize.focus({ preventScroll: true });
        }
      });
    }

    if (form) {
      form.addEventListener('submit', function (event) {
        var submitter = event.submitter || document.activeElement;
        var expressSubmit = submitter && (
          submitter.closest && submitter.closest('.shopify-payment-button') ||
          submitter.classList && submitter.classList.contains('shopify-payment-button__button')
        );

        var variant = resolveVariant();
        if (!variant || variant.available === false) {
          event.preventDefault();
          if (sizeStatus) sizeStatus.textContent = copy.select_prompt;
          var firstSize = root.querySelector('[data-ura4-size-input]:not(:disabled)');
          if (firstSize) firstSize.focus();
          return;
        }

        if (hiddenVariant) {
          hiddenVariant.value = variant.id;
          hiddenVariant.setAttribute('value', variant.id);
        }

        syncComponentItems(variant);
        if (expressSubmit) return;

        var addSubmit = !submitter || submitter === add || (
          submitter.matches && submitter.matches('[data-ura4-add]')
        );

        if (
          addSubmit &&
          window.URACartDrawer &&
          typeof window.URACartDrawer.addForm === 'function'
        ) {
          event.preventDefault();
          window.URACartDrawer.addForm(form, {
            button: add,
            label: addLabel,
            status: sizeStatus
          });
        }
      });
    }
  }

  function initAll(scope) {
    array((scope || document).querySelectorAll('[data-ura4-product]')).forEach(initProduct);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    }, { once: true });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

}());






